import React from 'react';

export const HeroSection: React.FC = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="home" 
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      <video
        autoPlay
        muted
        loop
        playsInline
        className="absolute inset-0 w-full h-full object-cover"
      >
        <source src="/assets/home-main.mp4" type="video/mp4" />
      </video>
  
      <div className="absolute inset-0 bg-black/50"></div>
      
      <div className="absolute top-20 left-20 w-64 h-64 bg-red-500/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 right-20 w-80 h-80 bg-blue-500/20 rounded-full blur-3xl"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="text-center lg:text-left">
            <div className="backdrop-blur-sm bg-white/10 rounded-2xl p-8 border border-white/20">
              <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
                Best Mobile 
                <span className="text-red-400"> Repair Shop</span> in Kochi
              </h1>
              <p className="text-xl text-gray-200 mb-8 leading-relaxed">
                Expert mobile, tablet, and smartwatch repair services with genuine parts, 
                transparent pricing, and same-day service. Trusted by thousands in Kochi.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                <button 
                  onClick={() => scrollToSection('contact')}
                  className="bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-full font-semibold text-lg transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
                >
                  Get Free Quote
                </button>
                <button 
                  onClick={() => scrollToSection('services')}
                  className="border-2 border-white text-white hover:bg-white hover:text-gray-900 px-8 py-4 rounded-full font-semibold text-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  Our Services
                </button>
              </div>
            </div>
          </div>

          <div className="flex justify-center lg:justify-end">
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 bg-white/95 backdrop-blur-sm border-t border-gray-200">
        <div className="container mx-auto px-4 py-6">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            <div className="flex items-center justify-center space-x-3">
              <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center">
                <i className="ri-truck-line text-red-600 text-xl"></i>
              </div>
              <div className="text-center md:text-left">
                <h4 className="font-semibold text-gray-900 text-sm">All-Kerala Courier</h4>
                <p className="text-gray-600 text-xs">Services Available</p>
              </div>
            </div>
            
            <div className="flex items-center justify-center space-x-3">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                <i className="ri-money-dollar-circle-line text-green-600 text-xl"></i>
              </div>
              <div className="text-center md:text-left">
                <h4 className="font-semibold text-gray-900 text-sm">Money Guarantee</h4>
                <p className="text-gray-600 text-xs">100% Refund</p>
              </div>
            </div>
            
            <div className="flex items-center justify-center space-x-3">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                <i className="ri-customer-service-2-line text-blue-600 text-xl"></i>
              </div>
              <div className="text-center md:text-left">
                <h4 className="font-semibold text-gray-900 text-sm">24/7 Support</h4>
                <p className="text-gray-600 text-xs">Always Available</p>
              </div>
            </div>
            
            <div className="flex items-center justify-center space-x-3">
              <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center">
                <i className="ri-shield-check-line text-purple-600 text-xl"></i>
              </div>
              <div className="text-center md:text-left">
                <h4 className="font-semibold text-gray-900 text-sm">Secure Payment</h4>
                <p className="text-gray-600 text-xs">Safe & Trusted</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};